import React from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';

type Props = {
  values: any;
  errors: any;
  setFieldValue: (arg1: string, arg2: string) => void;
  disabled: boolean;
};

const IDescriptionContainer = ({ values, errors, setFieldValue, disabled }: Props) => {
  const getContainerContent = () => {
    return (
      <Grid stackable columns={1} verticalAlign="bottom">
        <GridColumnInputWrapper
          value={values.technicalEquipment || ''}
          name="technicalEquipment"
          placeholder="inventory.details.page.description.container.description.input.placeholder"
          errors={errors}
          setFieldValue={setFieldValue}
          disabled={disabled}
          values={values}
          render={(props: any) => <InputWrapper {...props} type="text" />}
        />
      </Grid>
    );
  };

  return (
    <AccordionWrapper
      collapsed={false}
      accordionTitle="inventory.details.page.description.container.title"
      tooltip="inventory.details.page.description.container.title.tooltip"
      render={getContainerContent}
      className=""
    />
  );
};

export default IDescriptionContainer;
